<template>
  <div class="footer-wrapper">
    <footer class="footer-container">
      <div class="footer-inner">
        <div class="footer-content">
          <!-- 第一列：品牌与核心声明 -->
          <div class="footer-column brand-column">
            <div class="brand-title">
              <i class="fa-solid fa-cubes-stacked brand-icon"></i>
              <span>云语匀雨工作室</span>
            </div>
            <p class="brand-desc">
              致力于打造美观、高效且富有科技感创意技术生态。版权所有，侵权必究。
            </p>
            <div class="icp-info">
              <a href="https://beian.miit.gov.cn/" target="_blank" rel="noopener">
                皖ICP备2025100344号-1
              </a>
            </div>
          </div>

          <!-- 第二列：旗下生态 -->
          <div class="footer-column links-column">
            <h4 class="column-title">旗下生态</h4>
            <ul class="footer-links-list">
              <li>
                <a href="https://chess.4yshop.top" target="_blank" rel="noopener" class="eco-link">
                  <i class="fa-solid fa-gamepad"></i> 中国象棋 🎮
                </a>
              </li>
              <li>
                <a @click="$router.push('/')" class="eco-link">
                  <i class="fa-solid fa-square-share-nodes"></i> 个人小站 🚀
                </a>
              </li>
            </ul>
          </div>

          <!-- 第三列：用户指南 -->
          <div class="footer-column links-column">
            <h4 class="column-title">平台条例</h4>
            <ul class="footer-links-list">
              <li>
                <a @click="$router.push('/mianze')" class="rule-link">
                  <i class="fa-solid fa-shield-halved"></i> 免责声明 🛡️
                </a>
              </li>
              <li>
                <a @click="$router.push('/rules')" class="rule-link">
                  <i class="fa-solid fa-gavel"></i> 文章规则 📜
                </a>
              </li>
              <li>
                <a @click="emitGlobalEvent('show-submission')" class="rule-link">
                  <i class="fa-solid fa-file-shield"></i> 投稿规范 📤
                </a>
              </li>
            </ul>
          </div>

          <!-- 第四列：互动与支持 -->
          <div class="footer-column links-column">
            <h4 class="column-title">互动与支持</h4>
            <ul class="footer-links-list">
              <li>
                <a href="mailto:yunyvstudio@qq.com" target="_blank" rel="noopener" class="support-link">
                  <i class="fa-solid fa-envelope"></i> 侵权申诉 📧
                </a>
              </li>
              <li>
                <a @click="emitGlobalEvent('show-feedback')" class="support-link">
                  <i class="fa-solid fa-comment-dots"></i> 意见反馈 💬
                </a>
              </li>
              <li>
                <a @click="emitGlobalEvent('show-friendlink-apply')" class="support-link">
                  <i class="fa-solid fa-link"></i> 申请友链 🔗
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <!-- 底部微版权行 -->
      <div class="footer-bottom">
        <p>&copy; 2026 云语匀雨工作室. All Rights Reserved.</p>
      </div>
    </footer>
  </div>
</template>

<script>
import eventBus from '@/utils/eventBus'

export default {
  name: 'HomeFoot',
  methods: {
    emitGlobalEvent(eventName) {
      eventBus.emit(eventName)
    }
  }
}
</script>

<style scoped>
.footer-wrapper {
  margin: 0 20px 24px 20px;
}

.footer-container {
  background: rgba(255, 255, 255, 0.45);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.5);
  border-radius: 24px;
  padding: 32px 32px 16px 32px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04);
  transition: background 0.3s cubic-bezier(0.4, 0, 0.2, 1),
              border-color 0.3s cubic-bezier(0.4, 0, 0.2, 1),
              box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.footer-inner {
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
}

.footer-content {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 30px;
  margin-bottom: 24px;
}

.footer-column {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
}

.brand-column .brand-title {
  font-size: 1.25em;
  font-weight: 700;
  color: #1d1d1f;
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
  font-family: '爱点风雅黑', sans-serif;
}

.brand-icon {
  background: linear-gradient(135deg, #0071e3, #00c6ff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.brand-desc {
  font-size: 0.88em;
  color: #515154;
  line-height: 1.6;
  margin: 0 0 16px 0;
  max-width: 320px;
  font-family: '猫啃网糖圆体', sans-serif;
}

.icp-info a {
  font-size: 0.82em;
  color: #86868b;
  text-decoration: none;
  transition: color 0.2s ease;
}

.icp-info a:hover {
  color: #0071e3;
}

.column-title {
  font-size: 0.95em;
  font-weight: 600;
  color: #1d1d1f;
  margin: 0 0 16px 0;
  font-family: '爱点风雅黑', sans-serif;
}

.footer-links-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.rule-link, .eco-link, .support-link {
  font-size: 0.88em;
  color: #515154;
  text-decoration: none;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: all 0.2s ease;
  font-family: '猫啃网糖圆体', sans-serif;
}

.rule-link i, .eco-link i, .support-link i {
  font-size: 0.95em;
  color: #86868b;
  transition: transform 0.2s ease;
}

/* 悬停微动画效果 */
.eco-link:hover {
  color: #0071e3;
  transform: translateX(3px);
}

.eco-link:hover i {
  color: #0071e3;
}

.rule-link:hover {
  color: #4CAF50;
  transform: translateX(3px);
}

.rule-link:hover i {
  color: #4CAF50;
}

.support-link:hover {
  color: #ff9800;
  transform: translateX(3px);
}

.support-link:hover i {
  color: #ff9800;
}

.footer-bottom {
  border-top: 1px solid rgba(0, 0, 0, 0.08);
  padding-top: 16px;
  text-align: center;
}

.footer-bottom p {
  font-size: 0.8em;
  color: #86868b;
  margin: 0;
  font-family: '猫啃网糖圆体', sans-serif;
}

/* 夜间模式样式 */
body.dark-theme .footer-container {
  background: rgba(30, 30, 30, 0.65) !important;
  border-color: rgba(255, 255, 255, 0.08);
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
}

body.dark-theme .brand-title,
body.dark-theme .column-title {
  color: #f5f5f7;
}

body.dark-theme .brand-desc,
body.dark-theme .rule-link,
body.dark-theme .eco-link,
body.dark-theme .support-link {
  color: rgba(255, 255, 255, 0.7);
}

body.dark-theme .eco-link:hover {
  color: #87ceeb !important;
}

body.dark-theme .eco-link:hover i {
  color: #87ceeb !important;
}

body.dark-theme .rule-link:hover {
  color: #81c784 !important;
}

body.dark-theme .rule-link:hover i {
  color: #81c784 !important;
}

body.dark-theme .support-link:hover {
  color: #ffb74d !important;
}

body.dark-theme .support-link:hover i {
  color: #ffb74d !important;
}

body.dark-theme .footer-bottom {
  border-top-color: rgba(255, 255, 255, 0.1);
}

body.dark-theme .footer-bottom p,
body.dark-theme .icp-info a {
  color: rgba(255, 255, 255, 0.45);
}

/* 响应式调整 */
@media (max-width: 992px) {
  .footer-content {
    grid-template-columns: 1.5fr 1fr 1fr;
    gap: 20px;
  }
}

@media (max-width: 768px) {
  .footer-content {
    grid-template-columns: 1fr;
    gap: 28px;
  }
  .footer-container {
    padding: 28px 20px 16px 20px;
  }
  .footer-column {
    align-items: center;
    text-align: center;
  }
  .brand-desc {
    max-width: 100%;
    margin-bottom: 12px;
  }
  .column-title {
    margin: 0 0 10px 0;
  }
  .footer-links-list {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    gap: 16px;
  }
  .eco-link:hover, .rule-link:hover, .support-link:hover {
    transform: none;
  }
}

@media (max-width: 480px) {
  .footer-wrapper {
    margin: 0 10px 16px 10px;
    margin-bottom: 60px;
    padding-bottom: calc(env(safe-area-inset-bottom) + 10px);
  }
  .footer-container {
    padding: 20px 16px 12px 16px;
    border-radius: 18px;
  }
  .footer-links-list {
    gap: 12px;
  }
}
</style>
